import GlobalFooter from "@/components/GlobalFooter";

/**
 * Portal footer wrapper — delegates to <GlobalFooter variant="portal" /> so
 * the same brand-driven copyright + license + commercial-register + contact
 * channels appear under every public portal page, with extra bottom padding
 * to clear the floating Fahad avatar at the bottom-left of the viewport.
 */
export default function PortalFooter() {
  return <GlobalFooter variant="portal" />;
}
